import { useQuery } from '@tanstack/react-query';
import { Event } from '../../../types/Event';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchEvent = async (uuid: string, template: string | undefined) => {
  const config = template ? { params: { template } } : {};
  const response = await CustomAxios.get<Event>(`events/${uuid}`, config);
  const { data } = response;
  return data;
};

interface UseGetEventByIdProps {
  uuid: string;
  template?: string;
}
export function useGetEventById({ uuid, template }: UseGetEventByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allEvents, uuid],
    queryFn: () => fetchEvent(uuid, template),
  });

  return query;
}
